"use strict";
/*
 * Created on 03.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author MSu
 */


var WorkflowStatus =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WorkflowStatus, _DomainObject_1$Domai);

  function WorkflowStatus(entityId, previousStates, currentState, possibleStates, possibleActions) {
    var _this;

    _classCallCheck(this, WorkflowStatus);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WorkflowStatus).call(this));
    _this.entityId = entityId;
    _this.previousStates = previousStates;
    _this.currentState = currentState;
    _this.possibleStates = possibleStates;
    _this.possibleActions = possibleActions;
    return _this;
  }

  return WorkflowStatus;
}(DomainObject_1.DomainObject);

exports.WorkflowStatus = WorkflowStatus;